import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormatValueConversionCellRendererComponent } from './format-value-conversion-cell-renderer.component';

@NgModule({
  declarations: [FormatValueConversionCellRendererComponent],
  imports: [CommonModule],
  exports: [FormatValueConversionCellRendererComponent],
})
export class FormatValueConversionCellRendererModule {}
